export const scrollToHash = () => {
    let start;
    let position;
    let animationFrame;
    const initialPosition = 0;

    const element = document.getElementById(window.location.hash.replace(/#/g, ''));

    const requestAnimationFrame = window.requestAnimationFrame;
    const cancelAnimationFrame = window.cancelAnimationFrame;

    function step(timestamp) {
        if (start === undefined) {
            start = timestamp;
        }

        const duration = 1000;

        const elapsed = timestamp - start;

        // this just gives us a number between 0 (start) and 1 (end)
        const relativeProgress = elapsed / duration;

        const pow = Math.pow;

        function easeOutQuart(x) {
            return 1 - pow(1 - x, 4);
        }
        // ease out that number
        const easedProgress = easeOutQuart(relativeProgress);
        const targetPosition = element.offsetTop;
        const amountOfPixelsToScroll = initialPosition - targetPosition;

        // calculate new position for every thick of the requestAnimationFrame
        position = initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1);

        // set the scrollbar position
        window.scrollTo(0, position);

        const maxAvailableScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;

        // Stop when max scroll is reached
        if (initialPosition !== maxAvailableScroll && window.scrollY === maxAvailableScroll) {
            cancelAnimationFrame(animationFrame);
            return;
        }

        // repeat until the end is reached
        if (elapsed < duration) {
            animationFrame = requestAnimationFrame(step);
        }
    }

    animationFrame = requestAnimationFrame(step);
};
